exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__label___31adn{position:relative;display:flex;font-family:Poppins-Light;font-size:12px;letter-spacing:1px}.style__label___31adn.style__labelSpacing___wOSjF{padding-left:25px;align-items:center}.style__label___31adn.style__formBlock___1EpNj{height:46px}.style__label___31adn input{z-index:-1;opacity:0}.style__label___31adn:hover,.style__label___31adn input:hover{cursor:pointer}.style__checkbox___2WbIa{position:absolute;align-self:center;left:0;height:14px;width:14px;background:#fff;border:1px solid #9b9b9b}.style__checkbox___2WbIa:after{content:\"\";position:absolute;display:none}.style__checkbox___2WbIa.style__checked___14Tp6:after{display:block;left:4px;top:2px;width:4px;height:7px;border:solid #000;border-width:0 2px 2px 0;transform:rotate(45deg)}", ""]);

// exports
exports.locals = {
	"label": "style__label___31adn",
	"labelSpacing": "style__labelSpacing___wOSjF",
	"formBlock": "style__formBlock___1EpNj",
	"checkbox": "style__checkbox___2WbIa",
	"checked": "style__checked___14Tp6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/checkbox/style.css
// module id = 669
// module chunks = 0